// MapleStrikeAd.js — the pirate scene's third act: picks up where the navy
// cut ends; the Maple destroyer fires on the pirate and sinks it.
import React from "react";
import MaplePirateAd from "./MaplePirateAd";

export default function MapleStrikeAd() {
  return <MaplePirateAd variant="strike" />;
}
